export const getCssVariableValue = (variableName: string) =>
  // eslint-disable-next-line prettier/prettier
  getComputedStyle(document.documentElement)
    .getPropertyValue(variableName)
    .trim()
